import React from "react";
import { Loader2 } from "lucide-react";

export const PageHeader = ({ eyebrow, title, subtitle, right }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6 hp-fade-up">
    <div>
      {eyebrow && (
        <div className="text-xs uppercase tracking-[0.18em] font-mono font-medium text-[#8F7220] mb-2">
          {eyebrow}
        </div>
      )}
      <h1 className="text-2xl sm:text-3xl lg:text-4xl font-serif font-bold tracking-tight text-[#180D24]">
        {title}
      </h1>
      {subtitle && <p className="mt-2 text-sm text-[#756D7E] max-w-2xl">{subtitle}</p>}
    </div>
    {right}
  </div>
);

export const Panel = ({ children, className = "", ...rest }) => (
  <div
    className={`rounded-2xl bg-white border border-[#E4DCD3] shadow-[0_1px_3px_rgba(24,13,36,0.06)] ${className}`}
    {...rest}
  >
    {children}
  </div>
);

export const Loader = ({ label = "Loading heritage records…" }) => (
  <div className="flex items-center justify-center gap-3 py-20 text-[#756D7E]">
    <Loader2 className="animate-spin text-[#59288E]" size={20} />
    <span className="font-mono text-sm">{label}</span>
  </div>
);

export const Meter = ({ label, value }) => (
  <div>
    <div className="flex justify-between text-sm mb-1.5">
      <span className="text-[#1A171D]">{label}</span>
      <span className="font-mono font-semibold text-[#59288E]">{value}%</span>
    </div>
    <div className="h-2.5 rounded-full bg-[#ECE5D8] overflow-hidden">
      <div
        className="h-full rounded-full transition-all duration-700"
        style={{ width: `${value}%`, background: "linear-gradient(90deg,#59288E,#D4AF37)" }}
      />
    </div>
  </div>
);
